import React, { Component } from 'react';
import capa1 from './img/capa_01.jpg';
import capa2 from './img/capa_02.jpg';
import capa3 from './img/capa_03.jpg';
import capa4 from './img/capa_04.jpg';
import capa5 from './img/capa_05.jpg';
import capa6 from './img/capa_06.jpg';
import capa7 from './img/capa_07.jpg';


export default class Capa extends Component {

  parte1 = () => {
    return (
      <div>
      <img alt='Capítulo 1 dos estudos da CPA-10' title='Capítulo 1 dos estudos da CPA-10' src={capa1}/>
      <figcaption>Capítulo 1 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte2 = () => {
    return (
      <div>
      <img alt='Capítulo 2 dos estudos da CPA-10' title='Capítulo 2 dos estudos da CPA-10' src={capa2}/>
      <figcaption>Capítulo 2 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte3 = () => {
    return (
      <div>
      <img alt='Capítulo 3 dos estudos da CPA-10' title='Capítulo 3 dos estudos da CPA-10' src={capa3}/>
      <figcaption>Capítulo 3 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte4 = () => {
    return (
      <div>
        <img alt='Capítulo 4 dos estudos da CPA-10' title='Capítulo 4 dos estudos da CPA-10' src={capa4}/>
        <figcaption>Capítulo 4 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte5 = () => {
    return (
      <div>
      <img alt='Capítulo 5 dos estudos da CPA-10' title='Capítulo 5 dos estudos da CPA-10' src={capa5}/>
      <figcaption>Capítulo 5 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte6 = () => {
    return (
      <div>
      <img alt='Capítulo 6 dos estudos da CPA-10' title='Capítulo 6 dos estudos da CPA-10' src={capa6}/>
      <figcaption>Capítulo 6 dos estudos da CPA-10</figcaption>
      </div>
    );
  };
  parte7 = () => {
    return (
      <div>
      <img alt='Capítulo 7 dos estudos da CPA-10' title='Capítulo 7 dos estudos da CPA-10' src={capa7}/>
      <figcaption>Capítulo 7 dos estudos da CPA-10</figcaption>
      </div>
    );
  };



  capa = () =>{

    switch(this.props.path){
      case '/sistema-financeiro': return <this.parte1/>;

      case '/analise-do-perfil-investidor': return <this.parte2/>;

      case '/conceitos-basicos-economia-financas': return <this.parte3/>;

      case '/principios-de-investimento': return <this.parte4/>;

      case '/fundos-de-investimento': return <this.parte5/>;

      case '/renda-variavel-fixa': return <this.parte6/>;

      case '/previdencia': return <this.parte7/>;
      default:
    }
}
  render() {
    return (

      <section>
        <this.capa />
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Capa.js